<template>
    <div class='text-xs leading-3 text-gray-900 grid grid-cols-1' :class="`${!haveChildren ? ' bg-gray-100 ' : ''} ${padd === true ? ' pl-5 ' : ''}`">
        <div class="flex my-1.5">
            <div class="px-1 pt-1 flex-none">
                <button v-if="haveChildren" class="flex items-center relative inline-flex px-4 text-sm font-medium text-gray-700 w-full focus:outline-none">
                    <svg @click="toogleNode" class="ml-2 mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path v-if="!open" fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                        <path v-else d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                    </svg>
                </button>
                <button v-else class="items-center relative inline-flex px-4 text-sm font-medium text-gray-700 w-full focus:outline-none">
                    <svg class="ml-2 mr-2 h-4 w-4" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div v-for="header in headers" :key="header.title" :class="`${header.actions ? ' text-right ' : ' pt-1 '}`" class="px-1 flex-1">
                <span v-if="header.render" v-html="header.render(item)"> </span>
                <template v-else-if="header.data"> {{ item[header.data] }} </template>
                <span v-else-if="header.actions" class="relative z-0 inline-flex shadow-sm rounded-md">
                    <button v-for="(action, index) in header.actions" :key="index" type="button" :class="action.className" @click="action.action(item)" class="px-1 py-1 text-xs relative inline-flex items-center border border-gray-300 bg-white leading-4 text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150">
                        <span v-if="action.render" v-html="action.render"> </span>
                        {{ action.text }}
                    </button>
                </span>
            </div>
        </div>
        <div v-if="open">
            <tree-table
                v-for="child in children"
                :key="child.id"
                :item="child"
                :headers="headers"
                :padd="true"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "tree-table",
    props: {
        item: {
            type: Object,
            required: true
        },
        headers: {
            type: Array,
            required: true
        },
        padd: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            localItem: this.item,
            open: false
        }
    },
    computed: {
        children(){
            return this.localItem.children ?? [];
        },
        haveChildren(){
            return this.children.length > 0 ? true : false
        }
    },
    methods: {
        toogleNode() {
            this.open = !this.open;
        }
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: all .2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
